import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import defaultBook from '../../../Images/defaultBook.png';

type ListCoverImageProps = {
  src?: string;
  alt?: string;
  style?: React.CSSProperties;
  imgStyle?: React.CSSProperties;
  className?: string;
  objectFit?: React.CSSProperties['objectFit'];
  onLoad?: React.ReactEventHandler<HTMLImageElement>;
  onError?: React.ReactEventHandler<HTMLImageElement>;
};

/**
 * Mobile list cover image with an instant local placeholder.
 * The yellow background shows immediately while the remote thumbnail loads.
 */
const ListCoverImage = ({
  src,
  alt,
  style,
  imgStyle,
  className,
  objectFit = 'contain',
  onLoad,
  onError,
}: ListCoverImageProps) => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [src]);

  const imageSrc = src && !hasError ? src : defaultBook;

  return (
    <Box
      className={className}
      style={{
        position: 'relative',
        overflow: 'hidden',
        backgroundColor: '#fbc02d',
        backgroundImage: `url(${defaultBook})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        ...style,
      }}
    >
      <Box
        component="img"
        src={imageSrc}
        alt={alt || ''}
        decoding="async"
        onLoad={(event) => {
          onLoad?.(event);
        }}
        onError={(event) => {
          setHasError(true);
          onError?.(event);
        }}
        style={{
          width: '100%',
          height: '100%',
          display: 'block',
          objectFit,
          ...imgStyle,
        }}
      />
    </Box>
  );
};

export default ListCoverImage;
